import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
// import logo from './logo.svg'
import styled from 'styled-components'
import { Cards } from 'components/Cards'
// import Link from 'components/Link'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {/* add your content here */}
      <Cards
        title={properties?.title}
        lead={properties?.lead}
        width={properties?.width}
        caption={properties?.caption}
        source={properties?.source}
        legendRanking={properties?.legendRanking}
        colorMode={colorMode}
      ></Cards>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ tenant?: string }>`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  font-family: var(--font-sans-serif);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  background-color: var(--site-background);
  }

`
export default MainComponent
